<template>
  <div>
    <h2 :style="{ marginTop: '1em', marginBottom: '1em' }">Fulfillments</h2>
    <a-table
      :columns="tableColumn"
      :data-source="fulfillments.data"
      :loading="tableLoading"
      :pagination="pagination"
      class="tableStyle"
    >
      <template slot="expandedRowRender" slot-scope="record">
        <div>
          <a-card :bordered="false">
            <a-table
              :data-source="record.fulfillmentLines"
              :columns="productColumn"
              :loading="tableLoading"
              class="tableStyle"
            >
            </a-table>
          </a-card>
        </div>
      </template>
      <template slot="status" slot-scope="data">
        <status-component :status="data"></status-component>
      </template>
      <template slot="action" slot-scope="data">
        <a-dropdown>
          <a
            style="color: #98c14b"
            class="ant-dropdown-link"
            @click="(e) => e.preventDefault()"
          >
            <a-icon style="font-size: 25px" type="ellipsis" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-show="data.status === 0">
              <a @click="handleStages(data, 1)">Awaiting Pickup</a>
            </a-menu-item>
            <a-menu-item v-show="data.status === 0">
              <a @click="handleStages(data, 4)">Cancel</a>
            </a-menu-item>
            <a-menu-item v-show="data.status === 1">
              <a @click="handleStages(data, 2)">Awaiting Delivery</a>
            </a-menu-item>
            <a-menu-item v-show="data.status === 2">
              <a @click="handleStages(data, 3)">Delivered</a>
            </a-menu-item>
             <a-menu-item >
              <a @click="showPreview(data)">Preview</a>
            </a-menu-item>
            <a-menu-item >
              <a @click="showDownload(data)">Download</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </a-table>
    <preview-waybill ref="previewRef"></preview-waybill>
    <waybill-download ref="downloasRef"></waybill-download>

  </div>
</template>

<script>
import moment from "moment";
import StatusComponent from "@/components/shared-components/StatusComponent.vue";
import { NotificationMixins } from "@/mixins/NotificationMixins";
import PreviewWaybill from  '../common/PreviewWaybill.vue';
import WaybillDownload from  '../common/WaybillDownload.vue';



const productColumn = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Product Name",
    dataIndex: "productBrandName",
    key: "productBrandName",
  },
  {
    title: "Product Quantity",
    dataIndex: "quantity",
    key: "quantity",
  },
];
const fulfillmentColumn = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Expected At",
    dataIndex: "expectedAt",
    key: "expectedAt",
  },
  {
    title: "status",
    dataIndex: "statusLabel",
    scopedSlots: { customRender: "status" },
    key: "statusLabel",
  },
  {
    title: "Created Date",
    dataIndex: "createdAt",
    key: "createdAt",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  components: { StatusComponent, PreviewWaybill, WaybillDownload },
  props: {
    transfer: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: () => ({
    tableColumn: fulfillmentColumn,
    productColumn,
    pagination: {
      pageSize: 20,
    },
    tableLoading: false,
  }),
  mixins: [NotificationMixins],
  computed: {
    fulfillments() {
      const fulfillments =
        this.$store.getters["fulfillments/GetWarehouseFulfillments"];
      fulfillments.data.map((fulfillment) => {
        fulfillment['key'] = fulfillment.id
        fulfillment.createdAt = moment(fulfillment.createdAt).format(
          "DD-MMM-YYYY"
        );
        fulfillment.expectedAt = moment(fulfillment.expectedAt).format(
          "DD-MMM-YYYY"
        );
        fulfillment.action = fulfillment;
      });
      return fulfillments;
    },
  },

  methods: {
    async handleStages(fulfillment, stage) {
      const payload = {
        fulfillmentId: fulfillment.id,
        data: {
          status: stage,
        },
      };
      this.tableLoading = true;
      const res = await this.$store.dispatch(
        "fulfillments/ChangeFulfillmentStatus",
        payload
      );
      res.status === 200
        ? this.showSuccessAlert("successfully updated fulfillment status.")
        : this.showErrorAlert("Error: error updating fulfillment status.");
      this.tableLoading = false;
      this.$store.dispatch("fulfillments/FetchWarehouseFulfillments", {
        sourceLocationId: this.transfer.id,
        limit: -1,
      });
    },
    showPreview(data){
      const waybillInfo = {
        requestId: data.requestId,
        fulfillmentLines: data.fulfillmentLines.map(product => ({
          productBrandName: product.productBrandName,
          quantity: product.quantity,
          productId: product.productId,
          key: product.productId
        })),
        expectedAt: data.expectedAt,
        destinationLocationName: data.request.destinationLocationName,
        requestedBy: data.request.requestedBy,
        sourceLocationName: data.request.sourceLocationName
      }
      this.$refs.previewRef.showPreviewData(waybillInfo);
    },
    showDownload(data){
      const waybillInfo = {
        requestId: data.requestId,
        fulfillmentLines: data.fulfillmentLines.map(product => ({
          productBrandName: product.productBrandName,
          quantity: product.quantity,
          productId: product.productId,
          key: product.productId
        })),
        expectedAt: data.expectedAt,
        destinationLocationName: data.request.destinationLocationName,
        requestedBy: data.request.requestedBy,
        sourceLocationName: data.request.sourceLocationName
      }
      this.$refs.downloasRef.downloadWaybill(waybillInfo);
    },
  },

  mounted() {
    this.$store.dispatch("fulfillments/FetchWarehouseFulfillments", {
      sourceLocationId: this.transfer.id,
      limit: -1,
    });
  },
};
</script>

<style lang="scss" scoped>
.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>